import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "funeral-configurator",
  class: "container-fluid"
}
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navbar = _resolveComponent("navbar")!
  const _component_summary_path_segment_view = _resolveComponent("summary-path-segment-view")!
  const _component_path_view = _resolveComponent("path-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_navbar),
    _createVNode(_Transition, { name: "bounce" }, {
      default: _withCtx(() => [
        (_ctx.isSummaryActive)
          ? (_openBlock(), _createBlock(_component_summary_path_segment_view, { key: 0 }))
          : (_openBlock(), _createBlock(_component_path_view, {
              key: 1,
              "displayed-segments": _ctx.currentSegments
            }, null, 8, ["displayed-segments"]))
      ], undefined, true),
      _: 1
    }),
    _createElementVNode("div", {
      class: "fcb-footer",
      innerHTML: _ctx.footerText
    }, null, 8, _hoisted_2)
  ]))
}